export default __webpack_public_path__ + "static/media/60.40241c4b.svg";